/**
 * @module app.track.print
 */
import {makeIcon} from './poiicon';
import olFormatGeoJSON from 'ol/format/GeoJSON.js';
import {buffer, extend, getCenter} from "ol/extent";

class Controller {

  /**
   * @param {angularGettext.Catalog} gettextCatalog
   * @param {string} s3Url S3 url prefix.
   * @param {app.PrintHelper} appPrintHelper
   * @param {app.MapService} appMapService
   * @param {app.track.service} appTrackService
   * @ngInject
   */
  constructor(gettextCatalog, s3Url, appPrintHelper, appMapService, appTrackService) {

    /**
     * @type {angularGettext.Catalog}
     * @protected
     */
    this.gettextCatalog = gettextCatalog;

    /**
     * @type {string}
     * @private
     */
    this.s3Url_ = s3Url;

    /**
     * @private
     */
    this.printHelper_ = appPrintHelper;

    /**
     * @type {ol.format.GeoJSON}
     * @private
     */
    this.geojsonFormat_ = new olFormatGeoJSON();

    /**
     * @type {ol.Map}
     */
    this.map = appMapService.map;

    /**
     * @private
     * @type {app.track.service}
     */
    this.trackService_ = appTrackService;

  }

  /**
   * @export
   */
  showPrintPhotoText() {
    return this.trackService_.selectedTrackPois && this.trackService_.selectedTrackPois.features.length > 0;
  }

  /**
   * @export
   */
  printPhotoText() {
    if (!this.trackService_.selectedTrack) {
      return;
    }

    gtag('event', 'poi_print');

    const {color, name} = this.trackService_.selectedTrack.properties;
    const pois = this.trackService_.selectedTrackPois.features;

    // sort POIs
    pois.sort((poiA, poiB) => poiA['properties']['sort'] - poiB['properties']['sort']);

    const datasource = [];
    for (let i = 0; i < pois.length; i++) {
      const properties = pois[i]['properties'];
      let photo_filename = '';
      const photo = properties['photo'];
      if (photo) {
        photo_filename = this.s3Url_ + 'valid/' + photo + '_big.jpg';
      }
      const description = properties['description'];
      datasource.push({
        'icon': makeIcon(color, properties['sort']),
        'title': properties['title'],
        'description': description ? description : '',
        'photo': photo_filename
      });
    }

    // calculate the center and the zoomlevel of the current track
    const track = this.geojsonFormat_.readFeature(this.trackService_.selectedTrack);
    let extent = track.getGeometry().getExtent();
    pois.forEach(function(poi) {
      poi = this.geojsonFormat_.readFeature(poi);
      extent = extend(extent, poi.getGeometry().getExtent());
    }, this);
    extent = buffer(extent, 1000);

    const layout = `A4 portrait track ${this.gettextCatalog.currentLanguage}`;
    const scale = this.printHelper_.computeScaleForExtent(layout, extent);
    const center = getCenter(extent);
    this.printHelper_.print(this.map, name, layout, scale, center, datasource);
  }

}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'track': '<'
  },
  controller: Controller,
  templateUrl: 'js/app/track/print/partial.html'
};

export default angular.module('appTrackPrintComponent', []).component('appTrackPrint', component);
